import apiClient from "./api";
import { ClientBasedStatisticsResponse } from "../redux/reducers/dashboard/dashboard.types";

export interface CompanyData {
    id: string | number;
    name: string;
}

export interface AllCompaniesResponse {
    data: {
        companies: CompanyData[];
    }
}
export const getDijikolayClientData = async () => {
    return await apiClient.get(`api/dijikolay/customers`);
};

export const getClientStatisticsData = async () => {
    return await apiClient.get(`/api/admin-dashboard/client-statistics/`);
};

export const getSubscriptionManagementData = async () => {
    return await apiClient.get(`/api/admin-dashboard/subscription-management/`);
};

export const getClientBasedStatisticsData = async (
    page: number,
    limit: number,
    companyName?: string[]
): Promise<ClientBasedStatisticsResponse> => {
    return await apiClient.get<ClientBasedStatisticsResponse>(`/api/admin-dashboard/client-based-statistics/`, {
        params: {
            page,
            limit,
            ...(companyName?.length ? { companyName: companyName.join(',') } : {})
        }
    });
};

export const getAllCompaniesData = async (): Promise<AllCompaniesResponse> => {
    return await apiClient.get<AllCompaniesResponse>(`/api/admin/company/list`);
};